import { DotsThree } from '@phosphor-icons/react';
import { SideDropActions } from 'src/components/SideDropActions';
import type { SideDropAction } from 'src/components/SideDropActions';

type StepCardActionsProps = {
  stepNumber: number;
  onAddAbove?: () => void;
  onAddBelow?: () => void;
  onDelete?: () => void;
  disabled?: boolean;
};

export function StepCardActions({
  stepNumber,
  onAddAbove,
  onAddBelow,
  onDelete,
  disabled = false,
}: StepCardActionsProps) {
  const options: SideDropAction[] = [];
  if (stepNumber !== 1 && onAddAbove) {
    options.push({ label: 'Add step above', onClick: onAddAbove });
  }
  if (onAddBelow) {
    options.push({ label: 'Add step below', onClick: onAddBelow });
  }
  if (stepNumber !== 1 && onDelete) {
    options.push({ label: 'Delete step', color: 'error', onClick: onDelete });
  }

  if (options.length === 0) return null;

  if (disabled) {
    return null;
  }

  return (
    <SideDropActions options={options} zIndex={9999} TriggerIcon={DotsThree} />
  );
}

export default StepCardActions;
